import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { ContractForm } from 'pages/contracts/components/ContractForm';
import { useContractQuery } from 'services/contracts';
import { Loading } from 'components/Loading';
import { ErrorElement } from 'components/Error';
import { EContractStatus } from 'types/contracts';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  contractId: string;
  canEdit: boolean;
}

export function EditContractDialog({ isOpen, onClose, contractId, canEdit }: Props) {
  const { t } = useTranslation()
  const { data, isLoading, isError } = useContractQuery({ id: contractId })
  const finalCanEdit = canEdit && data?.status !== EContractStatus.PUBLISHED;

  return (
    <Dialog fullWidth open={isOpen} onClose={onClose}>
      <DialogTitle>
        {finalCanEdit ? t('edit-contract') : t('view-contract')}
      </DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Loading fullPage={false} />
        ) : isError ? (
          <ErrorElement />
        ) : (
          <ContractForm canEdit={finalCanEdit} onCancel={onClose} initialValues={data} />
        )}
      </DialogContent>
    </Dialog>
  )
}
